module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "w3-sidebar w3-pink w3-collapse w3-top w3-large w3-padding",
    style: ({
      display: _vm.visible ? 'block' : 'none'
    })
  }, [_c('div', {
    staticClass: "locale-container"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/flag_hu.png"),
      "alt": "flag hu"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLocale', 'hu')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/flag_en.png"),
      "alt": "flag en"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLocale', 'en')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/flag_de.png"),
      "alt": "flag de"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLocale', 'de')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w3-container logo-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/logo/logo_" + _vm.locale + ".png"),
      "alt": "BeCreative logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "w3-bar-block w3-padding-8 link-container"
  }, [_c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/rolunk"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Rólunk')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/hireink"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Híreink')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/termekeink"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Termékeink')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/agc"
    }
  }, [_vm._v("\n      AGC\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/referenciak"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Referenciák')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/tervezo"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Tervező')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "w3-bar-item w3-button w3-hover-white",
    attrs: {
      "to": "/kapcsolat"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Kapcsolat')) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w3-right-align foot"
  }, [_c('p', {
    staticClass: "w3-small",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('Contact text'))
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "w3-small"
  }, [_c('router-link', {
    staticClass: "statement-link",
    attrs: {
      "to": "/adatvedelmi-nyilatkozat"
    }
  }, [_vm._v("\n        Adatvédelmi nyilatkozat\n      ")]), _vm._v("\n      |\n      "), _c('router-link', {
    staticClass: "statement-link",
    attrs: {
      "to": "/jogi-nyilatkozat"
    }
  }, [_vm._v("\n        Jogi nyilatkozat\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.facebook.com/becreative.glass/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/facebook.svg"),
      "alt": "facebook"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7add05dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 948
// module chunks = 0